import { render, staticRenderFns } from "./IndicatorWithSubtitleDate.vue?vue&type=template&id=ea01b66c&"
import script from "./IndicatorWithSubtitleDate.vue?vue&type=script&lang=js&"
export * from "./IndicatorWithSubtitleDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "IndicatorWithSubtitleDate.vue"
export default component.exports